import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";

const WishListSection = () => {
  const { wishlist, toggleWishlist } = useWishlist();
  const { addToCart, isInCart } = useCart();

  return (
    <section className='cart py-80'>
      <div className='container container-lg'>
        <div className='row gy-4'>
          <div className='col-lg-12'>
            <div className='cart-table border border-gray-100 rounded-16 overflow-hidden shadow-sm'>
              <div className='overflow-x-auto scroll-sm scroll-sm-horizontal'>
                {wishlist.length > 0 ? (
                  <table className='table rounded-8 overflow-hidden'>
                    <thead>
                      <tr className='border-bottom border-neutral-100 bg-gray-50'>
                        <th className='h6 mb-0 text-lg fw-bold px-16 py-12 border-end border-neutral-100 text-center'>Delete</th>
                        <th className='h6 mb-0 text-lg fw-bold px-16 py-12 border-end border-neutral-100 text-center'>Product Name</th>
                        <th className='h6 mb-0 text-lg fw-bold px-16 py-12 border-end border-neutral-100 text-center'>Unit Price</th>
                        <th className='h6 mb-0 text-lg fw-bold px-16 py-12 text-center'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {wishlist.map((product) => {
                        const variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
                        const price = variant ? variant.price : (product.price || 0);
                        const image = (product.imageUrls && product.imageUrls[0]) || "assets/images/thumbs/product-img1.png";
                        const inCart = isInCart(product.id, variant?.id);
                        
                        return (
                          <tr key={product.id} className='border-bottom border-gray-100'>
                            <td className='px-16 py-12 border-end border-neutral-100 text-center'>
                              <button
                                onClick={() => toggleWishlist(product)}
                                type='button'
                                className='remove-tr-btn d-flex align-items-center justify-content-center gap-12 text-gray-400 hover-text-danger-600 transition-2 w-100'
                              >
                                <i className='ph ph-x-circle text-2xl' />
                                <span>Remove</span>
                              </button>
                            </td>
                            <td className='px-16 py-12 border-end border-neutral-100'>
                              <div className='table-product d-flex align-items-center gap-24'>
                                <Link to={`/product-details?id=${product.id}`} className='table-product__thumb border border-gray-100 rounded-12 overflow-hidden flex-center p-0 bg-gray-50'>
                                  <img src={image} alt={product.name} style={{ width: '60px', height: '60px', objectFit: 'cover' }} />
                                </Link>
                                <div className='table-product__content text-start'>
                                  <h6 className='title text-lg fw-bold mb-4'>
                                    <Link to={`/product-details?id=${product.id}`} className='link text-line-1 hover-text-main-600'>{product.name}</Link>
                                  </h6>
                                  <span className='text-xs fw-medium text-gray-500 uppercase tracking-wider'>{product.categoryName || "Cultures"}</span>
                                </div>
                              </div>
                            </td>
                            <td className='px-16 py-12 border-end border-neutral-100 text-center'>
                              <span className='text-lg fw-bold text-main-600'>Rs.{price}</span>
                            </td>
                            <td className='px-16 py-12 text-center'>
                              <button
                                onClick={() => {
                                    addToCart(product, variant);
                                }}
                                disabled={inCart}
                                className={`btn ${inCart ? 'bg-gray-400' : 'bg-main-600'} text-white rounded-12 px-24 py-10 fw-bold hover-bg-main-700 transition-2 flex-center gap-8 shadow-sm mx-auto`}
                                style={{ cursor: inCart ? 'not-allowed' : 'pointer' }}
                              >
                                <i className={inCart ? 'ph ph-check-circle' : 'ph ph-shopping-cart'} /> {inCart ? 'Added to Cart' : 'Add to Cart'}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center py-80 bg-gray-50 rounded-16 m-32">
                    <i className="ph ph-heart-break text-6xl text-gray-300 mb-16"></i>
                    <h5 className="text-gray-500">Your wishlist is empty.</h5>
                    <p className="text-gray-400 mb-24">Save items you love here to find them later.</p>
                    <Link to="/shop" >Start Shopping</Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WishListSection;
